const PRODUCTION_URI = "http://api.whirl.moonproduct.in";

module.exports = {
    ENDPOINTS: {
        URI: PRODUCTION_URI
      }
};
